"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.ProfileImage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var contexts_1 = require("../contexts");
var react_native_1 = require("react-native");
var centered_1 = require("./centered");
var ProfileImage = function (props) {
    var BlobCache = react_1["default"].useContext(contexts_1.BlobCacheProviderContext);
    if (BlobCache == null) {
        throw new Error('BlobCacheProviderContext is null');
    }
    return props.imageSrc != null && props.isLoading !== true
        ? ((0, jsx_runtime_1.jsx)(react_native_1.TouchableOpacity, __assign({ onPress: props.onClick }, { children: (0, jsx_runtime_1.jsx)(react_native_1.Image, { source: { uri: props.imageSrc }, style: {
                    width: props.width,
                    height: props.width,
                    borderRadius: props.width * 0.25
                } }) })))
        : ((0, jsx_runtime_1.jsx)(centered_1.Centered, __assign({ style: {
                width: props.width,
                height: props.width,
                borderRadius: props.width * 0.25,
                backgroundColor: 'rgba(255, 255, 255, 0.1)'
            } }, { children: (0, jsx_runtime_1.jsx)(BlobCache.LoadingComponent, {}) })));
};
exports.ProfileImage = ProfileImage;
